import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage, deleteToken } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyDvHd_KBBAh1Fn1DysfWi0DKcGA6kRw6JM',
  authDomain: 't-chat-fda69.firebaseapp.com',
  projectId: 't-chat-fda69',
  storageBucket: 't-chat-fda69.firebasestorage.app',
  messagingSenderId: '82028977459',
  appId: '1:82028977459:web:d16352a7dbb9a75194f246',
}

const VAPID_KEY = 'BH7iXdi-RlYar9OGeKMwqnUmp6BjzlqLfvQsXKcOVF2DzGxDUd7RfAGdpPDl1daTxhyxENsvwBNAeHhyFQjm6VA'

const app = initializeApp(firebaseConfig)
// getMessaging có thể throw trên iOS < 16.4 (không hỗ trợ Web Push)
let messaging = null
try { messaging = getMessaging(app) } catch {}

// Đăng ký / làm mới FCM token — gọi mỗi lần app mở để bắt token đã rotate
export async function registerPush(onForegroundMessage) {
  if (!messaging) return null
  if (!('Notification' in window) || !('serviceWorker' in navigator)) return null
  if (Notification.permission === 'denied') return null

  const permission = await Notification.requestPermission()
  if (permission !== 'granted') return null

  try {
    const sw = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
    await navigator.serviceWorker.ready

    // Xóa token cũ trước để tránh FCM trả về "Device unregistered"
    // khi push subscription đã bị invalidate sau khi SW cập nhật
    try { await deleteToken(messaging) } catch {}

    const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: sw })
    if (!token) return null

    if (onForegroundMessage) {
      onMessage(messaging, (payload) => onForegroundMessage(payload))
    }
    return token
  } catch (err) {
    console.warn('[FCM] Lỗi đăng ký push:', err.message)
    return null
  }
}
